export const ANT_MEDIA_SERVER_BAGELSS_EVENTS = {
  SCREEN_SHARE_VIDEO_PLAY_STARTED: "SCREEN_SHARE_VIDEO_PLAY_STARTED",
  SCREEN_SHARE_STREAM_RECIEVED: "SCREEN_SHARE_STREAM_RECIEVED",
  PLAY_STARTED: "PLAY_STARTED",
  PLAY_FINISHED: "PLAY_FINISHED",
  JOIN_ROOM_START: "JOIN_ROOM_START",
  JOIN_ROOM_SUCESS: "JOIN_ROOM_SUCESS",
  JOIN_ROOM_ERROR: "JOIN_ROOM_ERROR",
  LEAVE_ROOM_SUCCESS: "LEAVE_ROOM_SUCCESS",
  LEAVE_ROOM_SUCCESS_SCREEN_SHARE: "LEAVE_ROOM_SUCCESS_SCREEN_SHARE",
  PUBLISH_STOPPED: "PUBLISH_STOPPED",
  PUBLISH_STARTED: "PUBLISH_STARTED",
  STREAM_INFO: "STREAM_INFO",
  USER_SWITCHED_VIDEO_TO_CAMERA: "USER_SWITCHED_VIDEO_TO_CAMERA",
  USER_SWITCHED_VIDEO_TO_SCREEN: "USER_SWITCHED_VIDEO_TO_SCREEN",


  INITIALISED: "INITIALISED",
  USER_STARTED_PUBLISH_WITH_AUDIO: "USER_STARTED_PUBLISH_WITH_AUDIO",
  USER_STARTED_PUBLISH_WITH_NO_AUDIO: "USER_STARTED_PUBLISH_WITH_NO_AUDIO",
  USER_STARTED_PUBLISH_WITH_VIDEO: "USER_STARTED_PUBLISH_WITH_VIDEO",
  USER_STARTED_PUBLISH_WITH_NO_VIDEO: "USER_STARTED_PUBLISH_WITH_NO_VIDEO",
  CAMERA_CONTROLLER_INITIALIZED: "CAMERA_CONTROLLER_INITIALIZED",

  TEST_FOR: "TEST_FOR",
  VIDEO_CREATED: "VIDEO_CREATED",
  CAMERA_ROOM_JOINED: "CAMERA_ROOM_JOINED",
}

export const states = {
  NOT_IN_ROOM: "NOT_IN_ROOM",
  JOINING_ROOM: "JOINING_ROOM",
  JOINED_ROOM: "JOINED_ROOM"
}


export const STREAM_NAMES = {
  CAMERA: "CAMERA",
  CAMERA_TOUR: "CAMERA-TOUR",
  CAMERA_TOUR_GUIDE: "CAMERA-GUIDE",
}